/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBasketLineItemsModel,
  AddLineItemModel,
  BasketResponseModel,
  ValidationErrorResponse,
} from '../models/index';
import {
    AddBasketLineItemsModelFromJSON,
    AddBasketLineItemsModelToJSON,
    AddLineItemModelFromJSON,
    AddLineItemModelToJSON,
    BasketResponseModelFromJSON,
    BasketResponseModelToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';
import { HandleRequest } from '../../handle-request'
export type DeleteRequest = {
    catalog: string;
    id?: Array<string>;
    basketId?: string;
}

export type CreateLineRequest = {
    catalog: string;
    basketId?: string;
    addLineItemModel?: AddLineItemModel;
}

export type CreateLinesRequest = {
    catalog: string;
    basketId?: string;
    addBasketLineItemsModel?: AddBasketLineItemsModel;
}

export type UpdateOrCreateLineRequest = {
    catalog: string;
    basketId?: string;
    addLineItemModel?: AddLineItemModel;
}

export type UpdateOrCreateLinesRequest = {
    catalog: string;
    basketId?: string;
    addBasketLineItemsModel?: AddBasketLineItemsModel;
}



/**
 * 
 */
export class LinesApi extends runtime.BaseAPI {


    /**
     */
     _delete = HandleRequest.Handle<DeleteRequest,BasketResponseModel>('LinesApi__delete',async (requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling _delete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/line`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     createLine = HandleRequest.Handle<CreateLineRequest,BasketResponseModel>('LinesApi_createLine',async (requestParameters: CreateLineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling createLine().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/line`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddLineItemModelToJSON(requestParameters['addLineItemModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     createLines = HandleRequest.Handle<CreateLinesRequest,BasketResponseModel>('LinesApi_createLines',async (requestParameters: CreateLinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling createLines().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/lines`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBasketLineItemsModelToJSON(requestParameters['addBasketLineItemsModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     updateOrCreateLine = HandleRequest.Handle<UpdateOrCreateLineRequest,BasketResponseModel>('LinesApi_updateOrCreateLine',async (requestParameters: UpdateOrCreateLineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling updateOrCreateLine().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/line`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddLineItemModelToJSON(requestParameters['addLineItemModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


    /**
     */
     updateOrCreateLines = HandleRequest.Handle<UpdateOrCreateLinesRequest,BasketResponseModel>('LinesApi_updateOrCreateLines',async (requestParameters: UpdateOrCreateLinesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasketResponseModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling updateOrCreateLines().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['basketId'] != null) {
            queryParameters['basketId'] = requestParameters['basketId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/basket/lines`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddBasketLineItemsModelToJSON(requestParameters['addBasketLineItemsModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasketResponseModelFromJSON(jsonValue));
    })

    /**
     */


}
